import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebaseConfig';

function DatafromUsers() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const logsCol = collection(db, 'logs');
        const logsSnapshot = await getDocs(logsCol);
        const logsList = logsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        console.log('Logs:', logsList);
        setLogs(logsList);
      } catch (error) {
        console.error('Error fetching logs:', error);
      }
    };

    fetchLogs();
  }, []);

  return (
    <div className="min-h-screen bg-black text-yellow-200 text-white p-4">
      <h1 className="text-2xl font-bold mb-4">Logs</h1>
      <table className="w-full border border-yellow-200">
        <thead>
          <tr>
            <th className="border border-yellow-200 text-white p-2">ID</th>
            <th className="border border-yellow-200 text-white p-2">Data</th>
          </tr>
        </thead>
        <tbody>
          {logs.map(log => (
            <tr key={log.id}>
              <td className="border border-yellow-200 text-white p-2">{log.id}</td>
              <td className="border border-yellow-200 text-white p-2">
                <pre>{JSON.stringify(log, null, 2)}</pre>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default DatafromUsers;
